// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AayJssbrgDGRT3Gi9ZNv{text-decoration:none;margin-left:2px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/LearnMoreLink/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA,CACA,eAAA","sourcesContent":[".learnMoreLink {\n  text-decoration: none;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"learnMoreLink": `AayJssbrgDGRT3Gi9ZNv`
};
export default ___CSS_LOADER_EXPORT___;
